import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import { useSelector } from "react-redux";
import { FaTrash, FaPencilAlt } from "react-icons/fa";

const SELECT_MENU_Z_INDEX = 3600;


const useStyles = makeStyles((theme) => ({
  textField: {
    width: 'auto',
    minWidth: '250px',
    padding: '5px 0px',
    margin: '-8px 0 0 -5px',
  },
  menu: {
    width: 'auto',
    // top: '150px',
  },
  dropdownIconWheat: {
    color: "#ffffff", 
  },
  dropdownIconBlack: {
    color: "rgb(0 0 0 / 54%)",
  },
  smallBox: {
    width: '14%',
    padding: '5px 0px',
    margin: '-8px 0 0 -5px',
    '& .MuiSelect-iconOutlined': {
      right: '0px'
    }
  },
  listItem: (props) => ({
    color: '#777',
    backgroundColor: props.toggle ? '#ffffff' : '#292929',
    '&:hover': {
      backgroundColor: '#f0f0f0', // hover will now work
     
    },
    '&.Mui-selected': {
    },
  }),
  outlinedWhite: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'white',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'white',
      },
    },
  },
  noPadding: {
    paddingTop: '0px !important',
    paddingBottom: '0px !important',
  },
  categoryItem: {
    fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    fontSize: '15px',
    color: 'var(--appTextColor) !important',
    fontWeight: 700,
    opacity: '1 !important',
  }
}));

export default function DropDownBox(props) {
  const toggle = useSelector(state => state.setToggle.toggle);
  const classes = useStyles({ toggle });
  const items = props.items || [];

  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (open) {
        setOpen(false); // close dropdown when scrolling
      }
    };

    window.addEventListener("scroll", handleScroll, true);
    return () => {
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, [open]);

  return (
    <TextField
      id={props.id}
      name={props.name}
      select
      label={props.label ? props.label : ""}
      className={`${props.className} ${props.smallSelectBox ? classes.smallBox : classes.textField} ${toggle ? '' : classes.outlinedWhite}`}
      value={props.value}
      InputLabelProps={{ shrink: true }}
      SelectProps={{
        open: open,
        onOpen: () => setOpen(true),
        onClose: () => setOpen(false),
        ...(( props.onEdit || props.onDelete) && {
          renderValue: (value) => {
            const item = items.find(i => i.value === value);
            return item ? item.label : "";
          }
        }),
        classes: {         
          icon: toggle ? classes.dropdownIconBlack : classes.dropdownIconWheat, 
        },
        MenuProps: {
          style: {
            zIndex: props.menuZIndex || SELECT_MENU_Z_INDEX,
          },
          className: (props.smallBox ? "" : classes.menu),
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left"
          },
          getContentAnchorEl: null,
          PaperProps: {
            style: {
              zIndex: props.menuZIndex || SELECT_MENU_Z_INDEX,
            }
          },
          classes: {
            list: classes.noPadding,  // Apply noPadding class to remove padding
          }
        }
      }}
      margin={props.margin}
      variant={props.variant}
      onChange={props.onChange}
      disabled={props.disabled}
      onBlur={props.onBlur}
    >
      {items.length === 0
        ? <MenuItem value="" disabled />
        : items.map((option) => (
        <MenuItem
          key={option.value}
          value={option.value}
          className={`${classes.listItem} ${option.isCatagory ? classes.categoryItem : ''}`}
          disabled={option.disabled ? option.disabled : false}
          style={!option.isCatagory && (props.onEdit || props.onDelete) ? {display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingRight: '4px'} : {}}
        >
          <span>{option.label}</span>
          {!option.isCatagory && (props.onEdit || props.onDelete) && (
            <span style={{display: 'flex', gap: '2px', marginLeft: '8px'}}>
              {props.onEdit && (
                <button
                  title="Rename"
                  onMouseDown={(e) => { e.stopPropagation(); e.preventDefault(); }}
                  onClick={(e) => { e.stopPropagation(); e.preventDefault(); setOpen(false); props.onEdit(option.value); }}
                  style={{ background: "none", border: "none", cursor: "pointer", color: "#337ab7", padding: "2px 4px", lineHeight: 1 }}
                >
                  <FaPencilAlt size={11} style={{ color: "#337ab7" }} />
                </button>
              )}
              {props.onDelete && (
                <button
                  title="Delete"
                  onMouseDown={(e) => { e.stopPropagation(); e.preventDefault(); }}
                  onClick={(e) => { e.stopPropagation(); e.preventDefault(); setOpen(false); props.onDelete(option.value); }}
                  style={{ background: "none", border: "none", cursor: "pointer", color: "#c0392b", padding: "2px 4px", lineHeight: 1 }}
                >
                  <FaTrash size={11} style={{ color: "#337ab7" }} />
                </button>
              )}
            </span>
          )}
        </MenuItem>
      ))}
    </TextField>
  );
}
